class EnvHelper {

  static getEnvironment(): any {
    let result;
    const hostname = window.location.hostname;
    if (hostname.toLowerCase() === 'localhost')
      result = this.getLocalEnvironment();
    else if (hostname.toLowerCase() === '?????')
      result = this.getDevEnvironment();
    else if (hostname.toLowerCase() === 'nessweb-nessweb.apps.item-dev.openshift.ad.msnet.atf.gov')
      result = this.getDevOpenShiftEnvironment();
    else if (hostname.toLowerCase() === 'nessweb-nessweb.apps.item-test.openshift.ad.msnet.atf.gov')
      result = this.getTestOpenShiftEnvironment();
    else if (hostname.toLowerCase() === 'nesstest.atf.gov')
      result = this.getTrainingEnvironment();
    else if (hostname.toLowerCase() === 'nesstrainweb-nesstrainweb.apps.item-prod.openshift.ad.msnet.atf.gov')
      result = this.getTrainingOpenShiftEnvironment();
    else if (hostname.toLowerCase() === 'ness.atf.gov')
      result = this.getProdEnvironment();
    return result;
  }

  static getLocalEnvironment(): any {
    return {
      addressApiEndpoint: 'https://dgeoportal.ad.msnet.atf.gov/geocode/rest/services/Locators/NA_Point_Street/GeocodeServer/findAddressCandidates',
      webApplicationBaseUri: 'http://localhost:4200',
      apiEndpoint: 'http://localhost:5147',
      authCookieDomainKey: 'localhost',
      authCookieStorageKey: 'access_token',
      authRefreshTokenCookieStorageKey: 'refresh_token',
      authTokenExpiresStorageKey: 'nessUserAuthTokenExpires',
      authTokenStorageKey: 'nessUserAuthToken',
      authRefreshTokenStorageKey: 'nessUserRefreshToken',
      authTokenClientId: 'BDEB7BE48B3D4DCAB2B0B0B6188518A4',
      bannerMessages: 'LOCAL ENVIRONMENT',
      baseMapUrl: 'https://dgeoportal.ad.msnet.atf.gov/geocode/rest/services/SMP_BaseMap/MapServer',
      arcGISAPIUrl: 'https://dgeoportal.ad.msnet.atf.gov/portal/jsapi/jsapi4',
      pivLoginApiUrl: '/api/WindowsLogin/login?provider=Windows&returnUrl=LoginCallback',
      recaptcha_v3_site_key: '6LfdlNUZAAAAABm6kicsMgmBQ1lSJGCV6xH0WZH5',
      maxUploadFileSizeInBytes: 5242880,
      production: false,
      oktaBaseUrl: 'https://dojloginexternal-test.usdoj.gov',
      oktaLoginUrl: '/home/bookmark/0oatrjc2qrDEOehrv0j6/2557',
      oktaClientId: '0oaa81cqohD731a7S0j6',
      apiLoginUrl: '/api/okta/login',
      oktaVerifyMFAUrl: '/api/okta/verifymfatoken',
      oktaIssuer: '/oauth2/default',
      pbiReportDashboard: 'https://atf-analytics-test.atf.gov/Reports/powerbi/NIBIN%20and%20NESS/NIBIN%20Snapshot'
    };
  }

  static getDevEnvironment(): any {
    return {
      addressApiEndpoint: 'https://dgeoportal.ad.msnet.atf.gov/geocode/rest/services/Locators/NA_Point_Street/GeocodeServer/findAddressCandidates',
      webApplicationBaseUri: 'https://agw1dwvnesweb01.ad.msnet.atf.gov',
      apiEndpoint: 'https://agw1dwvnesapp01.ad.msnet.atf.gov',
      authCookieDomainKey: '.atf.gov',
      authCookieStorageKey: 'access_token',
      authRefreshTokenCookieStorageKey: 'refresh_token',
      authTokenExpiresStorageKey: 'nessUserAuthTokenExpires',
      authTokenStorageKey: 'nessUserAuthToken',
      authRefreshTokenStorageKey: 'nessUserRefreshToken',
      authTokenClientId: 'BDEB7BE48B3D4DCAB2B0B0B6188518A4',
      bannerMessages: 'DEVELOPER ENVIRONMENT',
      baseMapUrl: 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer',
      arcGISAPIUrl: 'https://dgeoportal.ad.msnet.atf.gov/portal/jsapi/jsapi4',
      pivLoginApiUrl: '/api/WindowsLogin/login?provider=Windows&returnUrl=LoginCallback',
      maxUploadFileSizeInBytes: 5242880,
      recaptcha_v3_site_key: '6LfdlNUZAAAAABm6kicsMgmBQ1lSJGCV6xH0WZH5',
      production: false,
      oktaBaseUrl: 'https://dojloginexternal-test.usdoj.gov',
      oktaLoginUrl: '/home/bookmark/0oatrjc2qrDEOehrv0j6/2557',
      oktaClientId: '0oaa81cqohD731a7S0j6',
      apiLoginUrl: '/api/okta/login',
      oktaVerifyMFAUrl: '/api/okta/verifymfatoken',
      oktaIssuer: '/oauth2/default',
      pbiReportDashboard: 'https://atf-analytics-test.atf.gov/Reports/powerbi/NIBIN%20and%20NESS/NIBIN%20Snapshot'

    };
  }


  static getDevOpenShiftEnvironment(): any {
    return {
      addressApiEndpoint: 'https://dgeoportal.ad.msnet.atf.gov/geocode/rest/services/Locators/NA_Point_Street/GeocodeServer/findAddressCandidates',
      webApplicationBaseUri: 'https://nessweb-nessweb.apps.item-dev.openshift.ad.msnet.atf.gov',
      apiEndpoint: 'https://nessapi-nessapi.apps.item-dev.openshift.ad.msnet.atf.gov',
      authCookieDomainKey: '.atf.gov',
      authCookieStorageKey: 'access_token',
      authRefreshTokenCookieStorageKey: 'refresh_token',
      authTokenExpiresStorageKey: 'nessUserAuthTokenExpires',
      authTokenStorageKey: 'nessUserAuthToken',
      authRefreshTokenStorageKey: 'nessUserRefreshToken',
      authTokenClientId: 'BDEB7BE48B3D4DCAB2B0B0B6188518A4',
      bannerMessages: 'DEV ENVIRONMENT',
      baseMapUrl: 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer',
      arcGISAPIUrl: 'https://dgeoportal.ad.msnet.atf.gov/portal/jsapi/jsapi4',
      pivLoginApiUrl: '/api/WindowsLogin/login?provider=Windows&returnUrl=LoginCallback',
      recaptcha_v3_site_key: '6LfdlNUZAAAAABm6kicsMgmBQ1lSJGCV6xH0WZH5',
      maxUploadFileSizeInBytes: 5242880,
      production: false,
      oktaBaseUrl: 'https://dojloginexternal-test.usdoj.gov',
      oktaLoginUrl: '/home/bookmark/0oatrjc2qrDEOehrv0j6/2557',
      oktaClientId: '0oaa81cqohD731a7S0j6',
      apiLoginUrl: '/api/okta/login',
      oktaVerifyMFAUrl: '/api/okta/verifymfatoken',
      oktaIssuer: '/oauth2/default',
      pbiReportDashboard: 'https://atf-analytics-test.atf.gov/Reports/powerbi/NIBIN%20and%20NESS/NIBIN%20Snapshot'
    };
  }

  static getTestOpenShiftEnvironment(): any {
    return {
      addressApiEndpoint: 'https://dgeoportal.ad.msnet.atf.gov/geocode/rest/services/Locators/NA_Point_Street/GeocodeServer/findAddressCandidates',
      webApplicationBaseUri: 'https://nessweb-nessweb.apps.item-test.openshift.ad.msnet.atf.gov',
      apiEndpoint: 'https://nessapi-nessapi.apps.item-test.openshift.ad.msnet.atf.gov',
      authCookieDomainKey: '.atf.gov',
      authCookieStorageKey: 'access_token',
      authRefreshTokenCookieStorageKey: 'refresh_token',
      authTokenExpiresStorageKey: 'nessUserAuthTokenExpires',
      authTokenStorageKey: 'nessUserAuthToken',
      authRefreshTokenStorageKey: 'nessUserRefreshToken',
      authTokenClientId: 'BDEB7BE48B3D4DCAB2B0B0B6188518A4',
      bannerMessages: 'TEST ENVIRONMENT',
      baseMapUrl: 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer',
      arcGISAPIUrl: 'https://dgeoportal.ad.msnet.atf.gov/portal/jsapi/jsapi4',
      pivLoginApiUrl: '/api/WindowsLogin/login?provider=Windows&returnUrl=LoginCallback',
      recaptcha_v3_site_key: '6LfdlNUZAAAAABm6kicsMgmBQ1lSJGCV6xH0WZH5',
      maxUploadFileSizeInBytes: 5242880,
      production: false,
      oktaBaseUrl: 'https://dojloginexternal-test.usdoj.gov',
      oktaLoginUrl: '/home/bookmark/0oas236ldN4ygtIha0j6/2557',
      oktaClientId: '0oaa81cqohD731a7S0j6',
      apiLoginUrl: '/api/okta/login',
      oktaVerifyMFAUrl: '/api/okta/verifymfatoken',
      oktaIssuer: '/oauth2/default',
      pbiReportDashboard: 'https://atf-analytics-test.atf.gov/Reports/powerbi/NIBIN%20and%20NESS/NIBIN%20Snapshot'
    };
  }

  static getTrainingEnvironment(): any {
    return {
      addressApiEndpoint: 'https://dgeoportal.ad.msnet.atf.gov/geocode/rest/services/Locators/NA_Point_Street/GeocodeServer/findAddressCandidates',
      webApplicationBaseUri: 'https://nesstest.atf.gov',
      apiEndpoint: 'https://nessapptest.atf.gov',
      authCookieDomainKey: '.atf.gov',
      authCookieStorageKey: 'access_token',
      authRefreshTokenCookieStorageKey: 'refresh_token',
      authTokenExpiresStorageKey: 'nessUserAuthTokenExpires',
      authTokenStorageKey: 'nessUserAuthToken',
      authRefreshTokenStorageKey: 'nessUserRefreshToken',
      authTokenClientId: 'BDEB7BE48B3D4DCAB2B0B0B6188518A4',
      bannerMessages: 'TRAINING ENVIRONMENT',
      baseMapUrl: 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer',
      arcGISAPIUrl: 'https://dgeoportal.ad.msnet.atf.gov/portal/jsapi/jsapi4',
      pivLoginApiUrl: '/api/WindowsLogin/login?provider=Windows&returnUrl=LoginCallback',
      maxUploadFileSizeInBytes: 5242880,
      recaptcha_v3_site_key: '6LfdlNUZAAAAABm6kicsMgmBQ1lSJGCV6xH0WZH5',
      production: true,
      oktaBaseUrl: 'https://dojloginexternal.usdoj.gov',
      oktaLoginUrl: '/home/bookmark/0oatw2gj0KjnavP1q0j6/2557',
      oktaClientId: '0oabkocmvVdVlJlUf0j6',
      apiLoginUrl: '/api/okta/login',
      oktaVerifyMFAUrl: '/api/okta/verifymfatoken',
      oktaIssuer: '/oauth2/default',
      pbiReportDashboard: 'https://atf-analytics.atf.gov/Reports/powerbi/NIBIN%20and%20NESS/NIBIN%20Snapshot'
    };
  }

  static getTrainingOpenShiftEnvironment(): any {
    return {
      addressApiEndpoint: 'https://dgeoportal.ad.msnet.atf.gov/geocode/rest/services/Locators/NA_Point_Street/GeocodeServer/findAddressCandidates',
      webApplicationBaseUri: 'https://nesstrainweb-nesstrainweb.apps.item-prod.openshift.ad.msnet.atf.gov',
      apiEndpoint: 'https://nesstrainapp-nesstrainapp.apps.item-prod.openshift.ad.msnet.atf.gov',
      authCookieDomainKey: '.atf.gov',
      authCookieStorageKey: 'access_token',
      authRefreshTokenCookieStorageKey: 'refresh_token',
      authTokenExpiresStorageKey: 'nessUserAuthTokenExpires',
      authTokenStorageKey: 'nessUserAuthToken',
      authRefreshTokenStorageKey: 'nessUserRefreshToken',
      authTokenClientId: 'BDEB7BE48B3D4DCAB2B0B0B6188518A4',
      bannerMessages: 'TRAINING ENVIRONMENT (OpenShift)',
      baseMapUrl: 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer',
      arcGISAPIUrl: 'https://dgeoportal.ad.msnet.atf.gov/portal/jsapi/jsapi4',
      pivLoginApiUrl: '/api/WindowsLogin/login?provider=Windows&returnUrl=LoginCallback',
      maxUploadFileSizeInBytes: 5242880,
      recaptcha_v3_site_key: '6LfdlNUZAAAAABm6kicsMgmBQ1lSJGCV6xH0WZH5',
      production: true,
      oktaBaseUrl: 'https://dojloginexternal.usdoj.gov',
      oktaLoginUrl: '/home/bookmark/0oatw2gj0KjnavP1q0j6/2557',
      oktaClientId: '0oabkocmvVdVlJlUf0j6',
      apiLoginUrl: '/api/okta/login',
      oktaVerifyMFAUrl: '/api/okta/verifymfatoken',
      oktaIssuer: '/oauth2/default',
      pbiReportDashboard: 'https://atf-analytics.atf.gov/Reports/powerbi/NIBIN%20and%20NESS/NIBIN%20Snapshot'
    };
  }

  static getProdEnvironment(): any {
    return {
      addressApiEndpoint: 'https://geoportal.ad.msnet.atf.gov/server/rest/services/Locators/NA_Point_Street/GeocodeServer/findAddressCandidates',
      webApplicationBaseUri: 'https://ness.atf.gov',
      apiEndpoint: 'https://nessapp.atf.gov',
      authCookieDomainKey: '.atf.gov',
      authCookieStorageKey: 'access_token',
      authRefreshTokenCookieStorageKey: 'refresh_token',
      authTokenExpiresStorageKey: 'nessUserAuthTokenExpires',
      authTokenStorageKey: 'nessUserAuthToken',
      authRefreshTokenStorageKey: 'nessUserRefreshToken',
      authTokenClientId: 'BDEB7BE48B3D4DCAB2B0B0B6188518A4',
      bannerMessages: '',
      baseMapUrl: 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer',
      arcGISAPIUrl: 'https://geoportal.ad.msnet.atf.gov/portal/jsapi/jsapi4',
      pivLoginApiUrl: '/api/WindowsLogin/login?provider=Windows&returnUrl=LoginCallback',
      maxUploadFileSizeInBytes: 5242880,
      recaptcha_v3_site_key: '6LfdlNUZAAAAABm6kicsMgmBQ1lSJGCV6xH0WZH5',
      production: true,
      oktaBaseUrl: 'https://dojloginexternal.usdoj.gov',
      oktaLoginUrl: '/home/bookmark/0oatw26mnc3hX7frH0j6/2557',
      oktaClientId: '0oabkocmvVdVlJlUf0j6',
      apiLoginUrl: '/api/okta/login',
      oktaVerifyMFAUrl: '/api/okta/verifymfatoken',
      oktaIssuer: '/oauth2/default',
      pbiReportDashboard: 'https://atf-analytics.atf.gov/Reports/powerbi/NIBIN%20and%20NESS/NIBIN%20Snapshot'
    };
  }

}

export const environment = EnvHelper.getEnvironment();

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
